module.exports = __webpack_public_path__ + "static/media/pause.06b75a9b.svg";